<template lang="pug">
  div
    v-btn(
      v-if="showModelCalculationButton"
      block
      @click="getCalculatedModel"
    ) Calculate data from model
</template>

<script>
import { mapGetters } from "vuex";
import Barrier from "@/utilities/barrier";
import availableBarrierTypes from "@/utilities/barrierTypes";
import api from "@/store/utils/api";

export default {
  name: "MapMenuCalculateFromModel",
  data() {
    return {
      showModelCalculationButton: true
    };
  },
  computed: {
    ...mapGetters([
      "filterDateTime",
      "filterDate",
      "filterTime",
      "filterButtonLoading",
      "currentMarkerID",
      "heatmapVisible"
    ])
  },
  methods: {
    getCalculatedModel: function() {
      api.get("/api/calcDatapointsFromModel").then(response => {
        this.$store
          .dispatch("SET_POINTS", response.points.map(Object.values))
          .then(() => {
            this.$store.dispatch("TOGGLE_HEATMAP").then(() => {
              // If the heatmap was just disabled, we are going to re-enable it again.
              if (!this.heatmapVisible) {
                this.$store.dispatch("TOGGLE_HEATMAP");
              }
            });
          });
        const barriers = [];
        let currentID = this.currentMarkerID;
        for (let barrier of response.barriers) {
          const currentBarrier = availableBarrierTypes.filter(
            b => b.type === barrier.type
          )[0];
          const name = `${currentBarrier.name} ${currentID}`;
          const b = new Barrier(
            currentID,
            barrier.type,
            name,
            { lat: barrier.lat, lng: barrier.lng },
            true
          );
          barriers.push(b);
          currentID++;
        }
        this.$store.dispatch("SET_BARRIERS", barriers);
        this.$store.dispatch("SET_MARKER_ID", currentID);
      });
    }
  }
};</script>
